import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Disclosure } from "@headlessui/react";
import { ReactComponent as Logo } from "assets/common/navigation/logo.svg";
import { ReactComponent as DownArrow } from "assets/common/navigation/downArrow.svg";
import { ReactComponent as Logout } from "assets/common/navigation/logoutIcon.svg";
import routerConstant from "service/constant/routerConstant";
import { navigationList } from "service/constant/navigation";
import { cls } from "shared/lib/util/classnames";

interface Props {
  children: React.ReactNode;
}

export function SideNavigation({ children }: Props) {
  const location = useLocation();
  const navigate = useNavigate();

  const handleMenuClick = (path: string) => {
    navigate(path);
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate(routerConstant.LOGIN.index);
  };

  return (
    <div className="flex">
      <div className="flex min-h-[100vh] max-w-[273px] grow flex-col gap-y-5 overflow-y-auto border-r bg-darkBlue-1 p-0">
        <div className="p-[32px] pb-[24px]">
          <Logo />
        </div>
        <nav className="flex flex-1 flex-col">
          <ul className="flex flex-1 flex-col gap-y-7">
            <li>
              <ul>
                {navigationList.map((item) => (
                  <li key={item.name}>
                    {!item.children ? (
                      <div
                        onClick={() => handleMenuClick(item.href)}
                        className={cls(
                          location.pathname.split("/")[1] === item.current
                            ? "bg-blue-1 text-white"
                            : "text-gray-2 hover:bg-blue-1 hover:bg-opacity-[0.05]",
                          "flex w-full cursor-pointer items-center gap-[16px] px-[32px] py-[14px] text-btn-SM2",
                        )}
                      >
                        {item.name}
                      </div>
                    ) : (
                      <Disclosure as="div">
                        {({ open }) => (
                          <>
                            <Disclosure.Button
                              className={cls(
                                location.pathname.split("/")[1] === item.current
                                  ? "bg-blue-1 text-white"
                                  : "text-gray-2 hover:bg-blue-1 hover:bg-opacity-[0.05]",
                                "flex w-full items-center justify-between px-[32px] py-[14px] text-btn-SM2",
                              )}
                            >
                              <div className="flex items-center gap-[16px]">
                                {item.name}
                              </div>
                              <DownArrow
                                className={cls(
                                  open && "rotate-180",
                                  location.pathname.split("/")[1] ===
                                    item.current &&
                                    "[&>*:nth-child(1)]:[&>*:nth-child(2)]:fill-white",
                                )}
                              />
                            </Disclosure.Button>
                            <Disclosure.Panel
                              as="ul"
                              className="bg-[#5698fb] bg-opacity-[0.2]"
                            >
                              {item.children.map((subItem) => (
                                <li key={subItem.name}>
                                  <Disclosure.Button
                                    as="div"
                                    onClick={() =>
                                      handleMenuClick(subItem.href)
                                    }
                                    className={cls(
                                      location.pathname.split("/")[1] ===
                                        item.current &&
                                        location.pathname.split("/")[2] ===
                                          subItem.current
                                        ? "text-white"
                                        : "text-gray-2 hover:bg-[#5698fb] hover:bg-opacity-[0.1]",
                                      "flex cursor-pointer items-center gap-[26px] px-[42px] py-[12px] text-btn-SM2",
                                    )}
                                  >
                                    <div
                                      className={cls(
                                        location.pathname.split("/")[1] ===
                                          item.current &&
                                          location.pathname.split("/")[2] ===
                                            subItem.current
                                          ? "bg-white"
                                          : "bg-gray-2",
                                        "h-[4px] w-[4px] rounded-full",
                                      )}
                                    />
                                    {subItem.name}
                                  </Disclosure.Button>
                                </li>
                              ))}
                            </Disclosure.Panel>
                          </>
                        )}
                      </Disclosure>
                    )}
                  </li>
                ))}
              </ul>
            </li>
            <li className="mt-auto px-[32px] py-[24px]">
              <button
                className="m-0 flex h-[38px] w-full items-center justify-center gap-[18px] rounded-[8px] border-[1px] border-gray-1 text-[14px] font-semibold leading-[17px] text-gray-6 text-opacity-[0.5]"
                onClick={handleLogout}
              >
                <Logout />
                로그아웃
              </button>
            </li>
          </ul>
        </nav>
      </div>
      {children}
    </div>
  );
}
